module.exports = __webpack_public_path__ + "img/house-chimney-user.48454f81.svg";